/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
/* eslint-disable no-unreachable */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/function-component-definition */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react'
import { graphql } from 'gatsby'
import styled, { createGlobalStyle } from 'styled-components'
import Plaatjie from '@ubo/plaatjie'

// Libraries
import Slider from 'react-slick'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import HeroProjects from 'components/elements/HeroProjects'
import ButtonDefaultOutline from 'components/elements/ButtonDefaultOutline'
import ConceptItem from 'components/elements/ConceptItem'
import Projecten from 'components/Projecten'
import parse from 'html-react-parser'

// Libraries
import Lightbox from 'lightbox-react'
import 'lightbox-react/style.css'

import chevonRightRed from 'img/icons/chevron-right-red.svg'

const SlickStyling = createGlobalStyle`
  /* Slider */
  .slick-slider
  {
      position: relative;
  
      display: block;
      box-sizing: border-box;
  
      -webkit-user-select: none;
         -moz-user-select: none;
          -ms-user-select: none;
              user-select: none;
  
      -webkit-touch-callout: none;
      -khtml-user-select: none;
      -ms-touch-action: pan-y;
          touch-action: pan-y;
      -webkit-tap-highlight-color: transparent;
  }
  
  .slick-list
  {
      position: relative;
  
      display: block;
      overflow: hidden;
  
      margin: 0;
      padding: 0;
  }
  .slick-list:focus
  {
      outline: none;
  }
  .slick-list.dragging
  {
      cursor: pointer;
      cursor: hand;
  }
  
  .slick-slider .slick-track,
  .slick-slider .slick-list
  {
      -webkit-transform: translate3d(0, 0, 0);
         -moz-transform: translate3d(0, 0, 0);
          -ms-transform: translate3d(0, 0, 0);
           -o-transform: translate3d(0, 0, 0);
              transform: translate3d(0, 0, 0);
  }
  
  .slick-track
  {
      position: relative;
      top: 0;
      left: 0;
  
      display: block;
      margin-left: auto;
      margin-right: auto;
  }
  .slick-track:before,
  .slick-track:after
  {
      display: table;
  
      content: '';
  }
  .slick-track:after
  {
      clear: both;
  }
  .slick-loading .slick-track
  {
      visibility: hidden;
  }
  
  .slick-slide
  {
      display: none;
      float: left;
  
      height: 100%;
      min-height: 1px;
  }
  [dir='rtl'] .slick-slide
  {
      float: right;
  }
  .slick-slide img
  {
      display: block;
  }
  .slick-slide.slick-loading img
  {
      display: none;
  }
  .slick-slide.dragging img
  {
      pointer-events: none;
  }
  .slick-initialized .slick-slide
  {
      display: block;
  }
  .slick-loading .slick-slide
  {
      visibility: hidden;
  }
  .slick-vertical .slick-slide
  {
      display: block;
  
      height: auto;
  
      border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
      display: none;
  }
  
  /* Arrows */
  .slick-prev,
  .slick-next
  {
      font-size: 0;
      line-height: 0;
  
      position: absolute;
      top: 50%;
  
      display: block;
  
      width: 20px;
      height: 20px;
      padding: 0;
      -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
      transform: translate(0, -50%);
  
      cursor: pointer;
  
      color: transparent;
      border: none;
      outline: none;
      background: transparent;
  }
  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus
  {
      color: transparent;
      outline: none;
      background: transparent;
  }
  .slick-prev:hover:before,
  .slick-prev:focus:before,
  .slick-next:hover:before,
  .slick-next:focus:before
  {
      opacity: 1;
  }
  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before
  {
      opacity: .25;
  }
  
  .slick-prev:before,
  .slick-next:before
  {
      content: "";
      display: block;
  
      opacity: .75;
      background-image: url(${chevonRightRed});
      background-repeat: no-repeat;
      background-size: contain;
      width: 12px;
      height: 14px;
  
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }
  
  .slick-prev
  {
      left: -25px;
      transform: rotate(180deg);
      top: 85px !important;
  }
  
  [dir='rtl'] .slick-prev
  {
      right: -25px;
      left: auto;
  }

  
  .slick-next
  {
      right: -25px;
      top: 95px !important;
  }
  [dir='rtl'] .slick-next
  {
      right: auto;
      left: -25px;
  }
  
  @media (max-width: 767.98px) {
    .slick-prev {
      left: 0;
    }
    
    .slick-next {
      right: 0;
    }
  }
`

const VideoFrame = styled.iframe`
  @media (max-width: 991px) {
    height: 190px;
  }
`

const ProjectDescription = styled.div`
  color: ${(props) => props.theme.color.text.main};
  font-size: ${(props) => props.theme.font.size.sm};
  line-height: 19px;

  & span {
    color: ${(props) => props.theme.color.text.contrast};
    font-style: italic;
  }
`

const GalleryImageWrapper = styled.div`
  outline: none;
  height: 200px;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  padding: 0 15px;
`

const GallerImage = styled(Plaatjie)`
  width: 100%;
  height: 100%;
`

export const pageQuery = graphql`
  query pageQuery($databaseId: Int) {
    wpProject(databaseId: { eq: $databaseId }) {
      databaseId
      id
      title
      uri
      projectrecap {
        banner {
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(width: 2000, quality: 100)
              meta: fluid(maxWidth: 800, toFormat: JPG) {
                src
              }
            }
          }
        }
        locatie
        opdrachtgever
        omschrijving
        fase
        livestream {
          iframe
        }
        videos {
          vimeoUrl
        }
        gallerij {
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(width: 1240, quality: 100)
            }
          }
          databaseId
        }
      }

      categories {
        nodes {
          id
          name
        }
      }
      woningbouw {
        nodes {
          id
          name
        }
      }
      renovatie {
        nodes {
          id
          name
        }
      }
      zakelijk {
        nodes {
          id
          name
        }
      }
      particulier {
        nodes {
          id
          name
        }
      }
      diversen {
        nodes {
          id
          name
        }
      }

      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublisher
        opengraphPublishedTime
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          sourceUrl
        }
        twitterImage {
          sourceUrl
        }
      }
    }
  }
`

const PageTemplate = ({
  data: {
    wpProject: {
      databaseId,
      title,
      projectrecap,
      categories,
      woningbouw,
      renovatie,
      zakelijk,
      particulier,
      diversen,
      seo,
    },
  },
}) => {
  const [mediaData, setMediaData] = useState({
    photoIndex: 0,
    isVisible: false,
  })

  const images = []

  images.push(projectrecap.banner)

  projectrecap.gallerij.forEach(({ localFile: { publicURL } }) => {
    images.push(publicURL)
  })

  const descriptionHTML = (
    <ProjectDescription>
      <div className="row mx-sm-0 my-3">
        <div className="col-sm-5 px-sm-0">
          <span>Locatie</span>
        </div>
        <div className="col-sm-7 px-sm-0 mb-3 mb-sm-0">
          {projectrecap.locatie}
        </div>
        <div className="col-sm-5 px-sm-0">
          <span>Opdrachtgever</span>
        </div>
        <div className="col-sm-7 px-sm-0 mb-3 mb-sm-0">
          {projectrecap.opdrachtgever}
        </div>
        <div className="col-sm-5 px-sm-0">
          <span>Fase</span>
        </div>
        <div className="col-sm-7 px-sm-0 mb-3 mb-sm-0">{projectrecap.fase}</div>
      </div>
      <span>Omschrijving</span>
      <br />
      {parse(projectrecap.omschrijving)}
    </ProjectDescription>
  )

  // eslint-disable-next-line no-unused-vars
  const titleHTML = (
    <h2
      className="font-size-xl text-center"
      style={{ width: '80%', margin: '0 auto' }}
    >
      {parse(title)}
    </h2>
  )

  let filteredCategories = categories
  let filteredWoningbouw = woningbouw
  let filteredZakelijk = zakelijk
  let filteredParticulier = particulier
  let filteredDiversen = diversen
  let filteredRenovatie = renovatie

  if (typeof localStorage !== 'undefined') {
    const projectFilters = localStorage.getItem('project-filters')

    if (projectFilters) {
      const localFilters = JSON.parse(projectFilters)

      if (localFilters.woningbouw && localFilters.woningbouw.length) {
        filteredWoningbouw = filteredWoningbouw.nodes.filter(
          ({ name }) => localFilters.woningbouw.indexOf(name) !== -1
        )

        if (!localFilters.categories || localFilters.categories.length === 0) {
          filteredCategories = []
        }

        if (!localFilters.renovatie || localFilters.renovatie.length === 0) {
          filteredRenovatie = []
        }
      }

      if (localFilters.zakelijk && localFilters.zakelijk.length) {
        filteredZakelijk = filteredZakelijk.nodes.filter(
          ({ name }) => localFilters.zakelijk.indexOf(name) !== -1
        )

        if (!localFilters.categories || localFilters.categories.length === 0) {
          filteredCategories = []
        }

        if (!localFilters.renovatie || localFilters.renovatie.length === 0) {
          filteredRenovatie = []
        }
      }

      if (localFilters.particulier && localFilters.particulier.length) {
        filteredParticulier = filteredParticulier.nodes.filter(
          ({ name }) => localFilters.particulier.indexOf(name) !== -1
        )

        if (!localFilters.categories || localFilters.categories.length === 0) {
          filteredCategories = []
        }

        if (!localFilters.renovatie || localFilters.renovatie.length === 0) {
          filteredRenovatie = []
        }
      }

      if (localFilters.diversen && localFilters.diversen.length) {
        filteredDiversen = filteredDiversen.nodes.filter(
          ({ name }) => localFilters.diversen.indexOf(name) !== -1
        )

        if (!localFilters.categories || localFilters.categories.length === 0) {
          filteredCategories = []
        }

        if (!localFilters.renovatie || localFilters.renovatie.length === 0) {
          filteredRenovatie = []
        }
      }

      if (localFilters.categories && localFilters.categories.length) {
        filteredCategories = filteredCategories.nodes.filter(
          ({ name }) => localFilters.categories.indexOf(name) !== -1
        )

        if (!localFilters.woningbouw || localFilters.woningbouw.length === 0) {
          filteredWoningbouw = []
        }

        if (!localFilters.renovatie || localFilters.renovatie.length === 0) {
          filteredRenovatie = []
        }
      }

      if (localFilters.renovatie && localFilters.renovatie.length) {
        filteredRenovatie = filteredRenovatie.nodes.filter(
          ({ name }) => localFilters.renovatie.indexOf(name) !== -1
        )

        if (!localFilters.woningbouw || localFilters.woningbouw.length === 0) {
          filteredWoningbouw = []
        }

        if (!localFilters.categories || localFilters.categories.length === 0) {
          filteredCategories = []
        }
      }
    }
  }

  return (
    <Layout>
      {seo && <SEO seo={seo} />}

      <HeroProjects />

      <section className="pt-lg-3">
        <ConceptItem
          onClickImage={() => {
            setMediaData({ photoIndex: 0, isVisible: true })
          }}
          item={{
            image: projectrecap.banner,
            titleHTML,
            descriptionHTML,
          }}
          timelaps={projectrecap.livestream}
        />
      </section>

      <section>
        <div className="container mb-5">
          <div className="row py-5">
            <div
              className={`col-lg-10 mx-auto ${projectrecap.videos ? 'mb-5' : ''
                }`}
            >
              {projectrecap.gallerij && (
                <div className="container mb-5">
                  <SlickStyling />
                  <Slider
                    dots={false}
                    infinite
                    slidesToShow={
                      projectrecap.gallerij.length > 3
                        ? 3
                        : projectrecap.gallerij.length
                    }
                    slidesToScroll={1}
                    speed={1000}
                    responsive={[
                      {
                        breakpoint: 996,
                        settings: {
                          slidesToShow: 4,
                        },
                      },
                      {
                        breakpoint: 768,
                        settings: {
                          slidesToShow: 2,
                        },
                      },
                      {
                        breakpoint: 400,
                        settings: {
                          slidesToShow: 1,
                        },
                      },
                    ]}
                  >
                    {projectrecap.gallerij.map((image, index) => {
                      const photoIndex = index + 1
                      return (
                        <GalleryImageWrapper
                          // eslint-disable-next-line react/no-array-index-key
                          key={photoIndex}
                          // className="col-6 col-sm-4 col-md-3 mb-4"
                          onClick={() =>
                            setMediaData({ photoIndex, isVisible: true })
                          }
                          onKeyPress={() => { }}
                          role="button"
                          tabIndex="0"
                          className="mx-auto d-block"
                        >
                          <GallerImage image={image} />
                        </GalleryImageWrapper>
                      )
                    })}
                  </Slider>
                </div>
              )}
            </div>
            {projectrecap.videos &&
              projectrecap.videos.map((video, index) => (
                <div className="col-lg-6 mb-4" key={index}>
                  <VideoFrame
                    src={video.vimeoUrl}
                    width="100%"
                    height="310"
                    frameBorder="0"
                    title="Video van het project"
                  />
                </div>
              ))}
          </div>
          <div className="row justify-content-center">
            <ButtonDefaultOutline to="/projecten/" back>
              Terug naar het
              <br />
              projectoverzicht
            </ButtonDefaultOutline>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="row pb-5">
            <div className="col-12 mb-5">
              <h2 className="text-center">Bekijk ook:</h2>
            </div>
            {filteredCategories && filteredCategories.nodes ? (
              <Projecten
                notId={databaseId}
                categoryIds={
                  filteredCategories && filteredCategories.length > 0
                    ? filteredCategories.map(({ id }) => id)
                    : []
                }
                woningbouwIds={
                  filteredWoningbouw && filteredWoningbouw.nodes.length > 0
                    ? filteredWoningbouw.nodes.map(({ id }) => id)
                    : []
                }
                zakelijkIds={
                  filteredZakelijk && filteredZakelijk.length > 0
                    ? filteredZakelijk.nodes.map(({ id }) => id)
                    : []
                }
                particulierIds={
                  filteredParticulier && filteredParticulier.length > 0
                    ? filteredParticulier.nodes.map(({ id }) => id)
                    : []
                }
                diversenIds={
                  filteredDiversen && filteredDiversen.length > 0
                    ? filteredDiversen.nodes.map(({ id }) => id)
                    : []
                }
                renovatieIds={
                  filteredRenovatie && filteredRenovatie.length > 0
                    ? filteredRenovatie.nodes.map(({ id }) => id)
                    : []
                }
                limit={2}
              />
            ) : (
              <Projecten
                notId={databaseId}
                categoryIds={
                  filteredCategories && filteredCategories.length > 0
                    ? filteredCategories.map(({ id }) => id)
                    : []
                }
                woningbouwIds={
                  filteredWoningbouw && filteredWoningbouw.nodes.length > 0
                    ? filteredWoningbouw.nodes.map(({ id }) => id)
                    : []
                }
                zakelijkIds={
                  filteredZakelijk && filteredZakelijk.length > 0
                    ? filteredZakelijk.map(({ id }) => id)
                    : []
                }
                particulierIds={
                  filteredParticulier && filteredParticulier.length > 0
                    ? filteredParticulier.map(({ id }) => id)
                    : []
                }
                diversenIds={
                  filteredDiversen && filteredDiversen.length > 0
                    ? filteredDiversen.map(({ id }) => id)
                    : []
                }
                renovatieIds={
                  filteredRenovatie && filteredRenovatie.length > 0 ? filteredRenovatie.map(({ id }) => id) : []
                }
                limit={2}
              />
            )}
          </div>
        </div>
      </section>

      {mediaData.isVisible && (
        <Lightbox
          mainSrc={images[mediaData.photoIndex]}
          nextSrc={images[(mediaData.photoIndex + 1) % images.length]}
          prevSrc={
            images[(mediaData.photoIndex + images.length - 1) % images.length]
          }
          onCloseRequest={() =>
            setMediaData({ ...mediaData, ...{ isVisible: false } })
          }
          onMovePrevRequest={() =>
            setMediaData({
              ...mediaData,
              ...{
                photoIndex:
                  (mediaData.photoIndex + images.length - 1) % images.length,
              },
            })
          }
          onMoveNextRequest={() =>
            setMediaData({
              ...mediaData,
              ...{ photoIndex: (mediaData.photoIndex + 1) % images.length },
            })
          }
        />
      )}
    </Layout>
  )
}

export default PageTemplate
